module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pFrontCover"
    }
  }), _c('a', {
    attrs: {
      "id": "pFrontFlap"
    }
  }), _c('a', {
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2007 by Thomas H. Cook")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced or"), _c('br'), _vm._v("\ntransmitted in any form or by any means, electronic or mechanical,"), _c('br'), _vm._v("\nincluding photocopy, recording, or any information storage and retrieval"), _c('br'), _vm._v("\nsystem, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("\nCook, Thomas H."), _c('br'), _vm._v("\nThe cloud of unknowing/Thomas H. Cook.—1st ed."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v("\n“An Otto Penzler book.”"), _c('br'), _vm._v("\n1. Brothers and sisters—Fiction. 2. Schizophrenia—Fiction. 3. Family—Fiction. 4. Psychological fiction. I.Title."), _c('br'), _vm._v("\nPS3553.O55465C57 2007"), _c('br'), _vm._v("\n813'.54—dc22 2006013951"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-15-101260-2 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v("-10: 0-15-101260-1")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-53815-0"), _c('br'), _vm._v("\nv2.1017")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d48f4458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0